import m from "../../geodata/es2015/burundiHigh";
window.am4geodata_burundiHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/burundiHigh.js
// module id = null
// module chunks = 